var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M20.99 2.25A9.44 9.44 0 0 0 11 2.1a9.44 9.44 0 0 0-9.99.15 1.14 1.14 0 0 0-.51.952v11.423a1.85 1.85 0 0 0 .825 1.545 1.91 1.91 0 0 0 1.785.172 8 8 0 0 1 7.5.75.75.75 0 0 0 .84 0 8 8 0 0 1 7.5-.75 1.89 1.89 0 0 0 2.392-.84c.144-.27.219-.571.218-.877V3.202a1.12 1.12 0 0 0-.57-.952M2.54 14.948a.43.43 0 0 1-.382 0 .35.35 0 0 1-.158-.3V3.398a7.92 7.92 0 0 1 8.25 0v11.79a9.43 9.43 0 0 0-7.71-.248zM20 14.625a.35.35 0 0 1-.157.3.43.43 0 0 1-.383 0 9.55 9.55 0 0 0-7.71.255V3.412a7.92 7.92 0 0 1 8.25 0z"
  })));
};
export default SvgBook;